export const title = "Busca Palabras"
export const description = "Busca las palabras, encuéntralas y con un clic, arrástralas hacia la casilla correcta para formar la frase."
